// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// example of importing the slice
// import counterReducer from './counterSlice';
import loginReducer from '../pages/auth/loginSlice';
import toastReducer from '../components/toastMessage/toastSlice';
import otpReducer from '../pages/auth/otpSlice';
import modelReducer from './slices/modelSlice';
import addAdminReducer from '../pages/AdminManagement/addAdminSlice'
import languageSlice from '../store/slices/languageSlice'
import listReducer from '../store/slices/listSlice'
import privilegeSlice from '../store/slices/privilegeSlice'
import phoneNumbersReducer from '../store/slices/phoneNumbersSlice'
import geolocationReducer from '../store/slices/geolocationSlice'
import businessAreasReducer from '../store/slices/businessAreasSlice'
import featureFlagsReducer from '../store/slices/featureFlags'
import addMDReducer from '../pages/UserManagement/MasterDistributorManagement/addMDSlice'
import upfrontPercentageSlice from '../store/slices/upfrontPercentageSlice';
import transactionSlice from './slices/addManualSlice'
import activeListSlice from './slices/activeListSlice';
import serviceFeeSlice from '../pages/MNOManagament/OnTargetAchievement/OnTargetAchievementSlice';
import transactionReducer from '../store/slices/transactionSlice'; 
import signatureSlice from '../store/slices/signatureSlice'; 
import userEmailSlice from '../store/slices/userEmail';
import corporateDetailsReducer from './slices/corporateDetailsSlice';
import expandedCorporateDetailsReducer from './slices/expandedCorporateDetailsSlice';
import adminProfileSlice from './slices/adminProfileSlice';
import balanceSheetReducer from './slices/balanceSheetSlice';

const languagePersistConfig = {
  key: 'language',
  storage,
};
const transactionPersistConfig = {
  key: 'transactionDetails',
  storage,
};
const persistedLanguageReducer = persistReducer(languagePersistConfig, languageSlice);
const persistedTransactionReducer = persistReducer(transactionPersistConfig, transactionReducer);

const rootReducer = {
  login: loginReducer,
  toast: toastReducer,
  otp: otpReducer,
  model: modelReducer,
  list: listReducer,
  addAdmin: addAdminReducer,
  language: persistedLanguageReducer,
  privileges: privilegeSlice,
  phoneNumbers: phoneNumbersReducer,
  geolocation: geolocationReducer,
  businessAreas: businessAreasReducer,
  addMD: addMDReducer,
  featureFlags: featureFlagsReducer,
  upfrontPercentageSlice: upfrontPercentageSlice,
  addManual: transactionSlice,
  activeList: activeListSlice,
  serviceFeeData: serviceFeeSlice,
  transactionDetails: persistedTransactionReducer,
  signature: signatureSlice,
  userEmail: userEmailSlice,
  corporateDetails: corporateDetailsReducer,
  expandedCorporateDetails: expandedCorporateDetailsReducer,
  adminProfile: adminProfileSlice,
  balanceSheet: balanceSheetReducer,
};

export const store = configureStore({
  reducer: rootReducer,
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
